import InvokeMcpSkillContent from './InvokeMcpSkillContent';

const invokeMcpSkill = {
  name: 'Invoke MCP Skill',
  Content: InvokeMcpSkillContent,
  setInitialContent: (content = {}) => {
    if (content.skill_name) {
      return content;
    }

    return { skill_name: '', arguments: {} };
  },
  valid: content => {
    return Boolean(content.skill_name);
  }
};

export default invokeMcpSkill;
